import { render, staticRenderFns } from "./TheTabClasificacionCie.vue?vue&type=template&id=cd72a014&"
import script from "./TheTabClasificacionCie.vue?vue&type=script&lang=js&"
export * from "./TheTabClasificacionCie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports